import { HttpContext, HttpContextToken } from '@angular/common/http'

import type { FeatureKey } from '@app/features/feature-keys.generated'

/**
 * Declarative feature gate metadata attached to an HttpRequest.
 *
 * Set at the call site (in providers), consumed by FeatureGateInterceptor.
 * When the feature is disabled for the active tenant, the interceptor
 * short-circuits the request and emits a synthetic response whose body is
 * `fallback`. The caller specifies `fallback` because only the caller knows
 * the response shape (number / array / object).
 */
export interface FeatureGate {
  readonly feature: FeatureKey
  readonly fallback: unknown
}

export const REQUIRES_FEATURE = new HttpContextToken<FeatureGate | null>(() => null)

export function withFeature<T>(feature: FeatureKey, fallback: T): HttpContext {
  return new HttpContext().set(REQUIRES_FEATURE, { feature, fallback })
}
